import { HTTPHeaders } from '../../shared/headers/Headers.js';
import { ContentDataType } from '../../shared/headers/contentType.js';
import { Err, Ok } from '../../../result/shared/result.js';
import { GenericError } from '../../../errors/shared/genericError.js';
import { HttpBodyParseError } from '../../../errors/shared/http.js';
import { BASE_CLIENT_NAMESPACE } from '../const.js';
import { urlToLog } from '../url.js';
import { None, Some } from '../../../option/shared/option.js';

const BASE_RES_ERR_DOMAIN = BASE_CLIENT_NAMESPACE + '.response';
/**
 * Обертка над данными ответа {@linkcode XMLHttpRequest}
 *
 * @export
 * @class HttpResponse
 * @implements {IResponse<Res>}
 * @template Res - тип тела ответа
 * */
class HttpResponse {
    statusCode;
    headers;
    requestServerName;
    url;
    parsedBody = None();
    responseContentType;
    response;
    constructor(data, params) {
        const { requestServerName, responseContentType, url } = params;
        this.headers = new HTTPHeaders(data.headers);
        this.response = data;
        this.statusCode = data.status;
        this.responseContentType =
            typeof responseContentType === 'function'
                ? responseContentType(this.headers, this.statusCode)
                : responseContentType;
        this.requestServerName = requestServerName;
        this.url = new URL(url || data.url);
    }
    get body() {
        return this.parsedBody
            .okOrElse(() => createParseError({
            message: 'Тело ответа отсутствует или он не было распарсено',
            statusCode: this.statusCode,
            requestServerName: this.requestServerName,
            responseContentType: this.responseContentType,
            url: this.url,
        }))
            .unwrap();
    }
    async compileBody() {
        try {
            switch (this.responseContentType) {
                case ContentDataType.Json: {
                    if (this.response.body === null) {
                        return Err(createParseError({
                            statusCode: this.statusCode,
                            message: 'В ответе вернулось пустое тело ответа',
                            responseContentType: this.responseContentType,
                            requestServerName: this.requestServerName,
                            url: this.url,
                        }));
                    }
                    this.parsedBody = Some((await this.response.json()));
                    break;
                }
                case ContentDataType.Blob:
                    this.parsedBody = Some((await this.response.blob()));
                    break;
                case ContentDataType.ArrayBuffer:
                    this.parsedBody = Some((await this.response.arrayBuffer()));
                    break;
                case ContentDataType.Bytes:
                    return Err(createParseError({
                        statusCode: this.statusCode,
                        responseContentType: this.responseContentType,
                        url: this.url,
                        message: `Тип данных ${this.responseContentType} не поддерживается`,
                        requestServerName: this.requestServerName,
                    }));
                case ContentDataType.Text:
                    this.parsedBody = Some((await this.response.text()));
                    break;
                default:
                    this.parsedBody = Some(undefined);
            }
            return Ok.Empty;
        }
        catch (error) {
            if (GenericError.isLike(error)) {
                return Err(error);
            }
            return Err(createParseError({
                error,
                responseContentType: this.responseContentType,
                requestServerName: this.requestServerName,
                statusCode: this.statusCode,
                url: this.url,
            }));
        }
    }
}
function createParseError(params) {
    const { error, responseContentType, requestServerName, statusCode, url, message } = params;
    return new HttpBodyParseError({
        domain: BASE_RES_ERR_DOMAIN + `.compile-body.${requestServerName}`,
        statusCode,
        url: urlToLog(url).toString(),
        responseType: responseContentType || 'empty',
        details: error,
        message: message || 'Не удалось распарсить тело ответа',
    });
}

export { HttpResponse };
//# sourceMappingURL=Response.js.map
